import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";


import {
  StyledQuestion,
  InfoArea,
  StyledSkipText,
  TextContainer,
  StyledInput,
  StyledAddressContainer,
  StyledInputLabelContainer,
  StyledInputLabel
 } from '../styles';

import Input from '../../../../components/inputField';
import { FunctionalButton } from "../../../../components/functionalButton";
import { LastSkip } from '../lastSkip';

export const CurrentYear = ({
  handleNext,
  onboardingData,
  setOnboardingData,
  setPanel,
  setIsLastPanel,
  setPreviousStepPanel,
  prequalifyData,
  setPrequalifyData
}) => {

  setIsLastPanel(false);
  setPreviousStepPanel(2);

  const isMobile = useMediaQuery({ maxWidth: 960 });
  const data = prequalifyData.annual;
  const [selected, setSelected] = useState(0);

  const currentYear = new Date().getFullYear();

  return (
    <>  
      <StyledQuestion isMobile={isMobile} width="650px">Please enter your annual safety records for {currentYear-1}</StyledQuestion>
        <StyledAddressContainer>
          <StyledInputLabelContainer>
            <StyledInputLabel for="locality">Industry Classification Code, or Equivalent</StyledInputLabel>
            <StyledInput id="locality" required width='310' 
            value={(data["safety_records"] && (data["safety_records"][`${currentYear-1}`]["classCode"] || data["safety_records"][`${currentYear-1}`]["classCode"] == 0)) ? data["safety_records"][`${currentYear-1}`]["classCode"] : ''}
            onChange={(event) => setPrequalifyData(`annual.safety_records.${currentYear-1}.classCode`, event.target.value)}
            />
          </StyledInputLabelContainer>
          <StyledInputLabelContainer>
            <StyledInputLabel for="locality">Industry Base Rate</StyledInputLabel>
            <StyledInput id="locality" required width='310' 
            value={(data["safety_records"] && (data["safety_records"][`${currentYear-1}`]["baseRate"] || data["safety_records"][`${currentYear-1}`]["baseRate"] == 0)) ? data["safety_records"][`${currentYear-1}`]["baseRate"] : ''}
            onChange={(event) => setPrequalifyData(`annual.safety_records.${currentYear-1}.baseRate`, event.target.value)}
            />
          </StyledInputLabelContainer>
          
        </StyledAddressContainer>
        <StyledAddressContainer>
          <StyledInputLabelContainer>
            <StyledInputLabel for="state">Company’s Experience Rate</StyledInputLabel>
            <StyledInput id="state" required width='310' 
            value={(data["safety_records"] && (data["safety_records"][`${currentYear-1}`]["expRate"] || data["safety_records"][`${currentYear-1}`]["expRate"] == 0)) ? data["safety_records"][`${currentYear-1}`]["expRate"] : ''}
            onChange={(event) => setPrequalifyData(`annual.safety_records.${currentYear-1}.expRate`, event.target.value)}
            />
          </StyledInputLabelContainer>
          <StyledInputLabelContainer>
            <StyledInputLabel for="locality">Fatalities (Actual Number)</StyledInputLabel>
            <StyledInput id="locality" required width='310' 
            value={(data["safety_records"] && (data["safety_records"][`${currentYear-1}`]["fatalities"] || data["safety_records"][`${currentYear-1}`]["fatalities"] == 0)) ? data["safety_records"][`${currentYear-1}`]["fatalities"] : ''}
            onChange={(event) => setPrequalifyData(`annual.safety_records.${currentYear-1}.fatalities`, event.target.value)}
            />
          </StyledInputLabelContainer>
        </StyledAddressContainer>
    

          <StyledInputLabelContainer marginRight='325'>
              <StyledInputLabel for="state">Lost Time Incident Frequency (LTIF) Rate </StyledInputLabel>
              <StyledInput id="state" required width='310' 
              value={(data["safety_records"] && (data["safety_records"][`${currentYear-1}`]["lostRate"] || data["safety_records"][`${currentYear-1}`]["lostRates"] == 0)) ? data["safety_records"][`${currentYear-1}`]["lostRate"] : ''}
              onChange={(event) => setPrequalifyData(`annual.safety_records.${currentYear-1}.lostRate`, event.target.value)}
              />
          </StyledInputLabelContainer>
        <FunctionalButton
          buttonTitle="Next"
          handleButton={() => setPanel(2)}
          width="200px"
          marginRight="0px"
          marginTop="48px"
        />
    </>
  );
}
